export const ErrorTypes = {
    unexpected: 'Unexpected',
    application: 'ApplicationError',
    api: 'ApiError'
}